import React from "react";

function Terms(props) {
  return (
    <p className="text-sm mt-6 text-light">
      By continuing, you agree to our <span className="pri">Terms Of Use</span>,
      and <span className="pri">Privacy Policy</span>
    </p>
  );
}

export default Terms;
